
// Slider
document.addEventListener('DOMContentLoaded', function () {

    // Slider Basic
    $('.slider-basic').each(function () {
        var slider = $(this);
        slider.slick({
            arrows: true,
            infinite: true,
            autoplay: false,
            autoplaySpeed: 4800,
            pauseOnHover: true,
            speed: 500,
            adaptiveHeight: true,
            dots: false,

            responsive: [{
                breakpoint: 768,
                settings: {
                    arrows: false,
                    dots: true
                }
            }]
        });
    });

    // Slider Col
    $('.slider-col').each(function () {
        var slider = $(this);
        slider.slick({
            arrows: true,
            infinite: false,
            autoplay: false,
            autoplaySpeed: 4800,
            speed: 500,
            adaptiveHeight: true,
            dots: false,
            slidesToScroll: 1,
            swipeToSlide: true,
        });
    });

    //  Slider Stage
    $('.slider-stage').each(function () {
        var slider: any = $(this);
        slider.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            infinite: true,
            autoplay: true,
            autoplaySpeed: 6500,
            speed: 700,
            pauseOnHover: true,
            dots: false,

            responsive: [{
                breakpoint: 768,
                settings: {
                    arrows: false,
                    dots: true
                }
            }]
        });
    });

});
